module.exports = __webpack_public_path__ + "img/b98642a.jpg";